import * as React from "react";
const SvgFiRrDewpoint = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dewpoint_svg__a)">
      <path
        fill="#062147"
        d="M10 24A10.05 10.05 0 0 1 0 14C0 8.663 6.5 1.751 6.771 1.459A4.29 4.29 0 0 1 10.006 0a4.3 4.3 0 0 1 3.266 1.5c2.771 3.023 11 12.486 3.8 19.573A9.94 9.94 0 0 1 10 24m.006-22a2.31 2.31 0 0 0-1.752.8C8.161 2.9 2 9.459 2 14c-.115 7.009 8.783 10.694 13.657 5.657 6.218-6.007-1.944-14.6-3.866-16.819A2.34 2.34 0 0 0 10.007 2zM21 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dewpoint_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDewpoint;
